export default __webpack_public_path__ + "static/process-mobile-f763de14339b46c2f2076a576e7407c0.svg";